import { nsPlan } from '@/app/i18n/namespaces';
import Info from '@/common-utils/components/renders/info/Info';
import ICONS from '@/common-utils/enums/icons';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS: {
        key: 'shouldAutoActivateSubscriptions',
        type: 'boolean',
        entity: 'keys.auto_activate_short',
        namespace: nsPlan,
        enableSorting: true,
        extraInfo: ({ show }) => (show && <Info entity='keys.auto_activate_alert' namespace={nsPlan} icon={ICONS.DEFAULT_PLAN} variant='success' />)
    },
    LABEL: {
        key: 'label',
        type: 'text',
        entity: 'keys.label',
        namespace: nsPlan,
        enableSorting: true,
        filter: 'input',
        placeholder: 'filter.placeholder.label'
    },
    PRODUCT_CODE: {
        key: 'productCode',
        type: 'text',
        entity: 'keys.product_code',
        namespace: nsPlan,
        enableSorting: true,
        filter: 'input',
        placeholder: 'filter.placeholder.product_code'
    },
    PARENT_SUBSCRIPTION_PLAN: {
        key: 'parentSubscriptionPlan',
        LABEL: {
            parentKeys: ['parentSubscriptionPlan'],
            key: 'label',
            type: 'text',
            entity: 'keys.parent_subscription_label',
            namespace: nsPlan,
            filter: 'input',
            placeholder: 'filter.placeholder.parent_subscription_label',
            isNested: true
        },
        UUID: {
            parentKeys: ['parentSubscriptionPlan'],
            key: 'uuid'
        }
    },
    OWNER_ORGANIZATION: {
        key: 'ownerOrganization'
    },
    ALLOWED_CLIENTS: {
        key: 'allowedClients',
        entity: 'plan_allowed_clients',
        type: 'array',
        UUID: {
            parentKeys: ['allowedClients'],
            key: 'uuid'
        },
        LEGAL_NAME: {
            parentKeys: ['allowedClients'],
            key: 'legalName'
        }
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'keys.created_at',
        namespace: nsPlan,
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        entity: 'keys.updated_at',
        namespace: nsPlan,
        enableSorting: true,
        filter: 'date'
    },
    SHOULD_BLOCK_NEW_POS: {
        key: 'shouldBlockNewPOS',
        type: 'text',
        entity: 'organization_should_block_new_pos_title',
        namespace: nsPlan
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    }
};